<template>
    <v-container
        fluid
    >
        <v-dialog v-model="dialogConfirm" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text align="center">
                    Selecciona <b>Sí</b> o <b>No</b>.<br><br>
                    <v-btn color="primary" @click="dialogConfirm = false">{{$t('aceptar')}}</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal para mostrar a los Residente(s)    -->
        <v-dialog v-model="dialog_residente" scrollable max-width="400">
            <v-card>
                <v-toolbar dark  color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_residente')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            icon
                            @click="dialog_residente = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-layout row wrap>
                        <v-flex xs12>
                        <v-flex
                            class="pl-3 pr-3 pt-3 pb-3"
                            xs12
                        >
                            <div class="wrapper">
                                <v-img
                                        :src="editedItem.idUser.avatar"
                                ></v-img>
                            </div>
                        </v-flex>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-account"
                                    :label="$t('Nombre')"
                                    :value="editedItem.idUser.first_name"
                                    readonly
                                    outlined
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-account-outline"
                                    :label="$t('Apellido')"
                                    :value="editedItem.idUser.last_name"
                                    readonly
                                    outlined
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-cellphone"
                                    :label="$t('celular')"
                                    :value="editedItem.idUser.cellNumber"
                                    readonly
                                    outlined
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-email"
                                    label="E-Mail"
                                    :value="editedItem.idUser.email"
                                    readonly
                                    outlined
                            ></v-text-field>
                        </v-flex>
<!--                        <v-flex xs12>-->
<!--                            <v-checkbox-->
<!--                                    class="pl-3 pr-3"-->
<!--                                    :label="$t('puede_enviar')"-->
<!--                                    v-model="editedItem.puede_enviar"-->
<!--                                    readonly-->
<!--                                    outlined-->
<!--                            ></v-checkbox>-->
<!--                        </v-flex>-->
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-row
                align="center"
                justify="center"
        >
            <v-col
                cols="12"
                xs="12"
                sm="8"
                md="6"
                lg="6"
                xl="6"
            >
        <v-card
            class="elevation-5"
        >
            <v-toolbar
                class="mb-5"
                dark
                color="primary"
            >
                <v-toolbar-title>
                    <v-icon
                        right
                        dark
                    >
                        mdi-home-edit
                    </v-icon>
                    {{currentTitle}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-avatar
                    color="primary lighten-2"
                    class="subheading white--text align-self-center"
                    size="60"
                    v-text="$t('paso') + ' ' +  step + '/3'"
                ></v-avatar>
            </v-toolbar>
            <v-card-actions>
                <v-btn
                    :hidden="step === 1 "
                    color="primary"
                    depressed
                    @click="step--"
                >
                    <v-icon left>mdi-arrow-left-bold</v-icon>
                    {{$t('reverso')}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    :hidden="step === 3"
                    color="primary"
                    depressed
                    @click="step++"
                >
                    {{$t('continuar')}}
                    <v-icon right>mdi-arrow-right-bold</v-icon>
                </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-window
                v-model="step"
            >
                <v-window-item :value="1">
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        class="pl-3 pr-3"
                                        :label="$t('nombre_calle')"
                                        :value="houseInfo[0].street"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm3>
                                <v-text-field
                                        class="pl-3 pr-3"
                                        :label="$t('numero_casa')"
                                        :value="houseInfo[0].number"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="2">
                    <v-card-text>
                        <v-layout row wrap>
                                <v-flex
                                    class="pl-3 pr-3 pt-3 pb-3"
                                    xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfo[0].main_residents[0].idUser.idFront"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                    class="pl-3 pr-3 pt-3 pb-3"
                                    xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfo[0].main_residents[0].idUser.idBack"
                                    ></v-img>
                                </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <br>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                        class="pl-3 pr-3"
                                        prepend-icon="mdi-account"
                                        :label="$t('Nombre')"
                                        :value="houseInfo[0].main_residents[0].idUser.first_name"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                        class="pl-3 pr-3"
                                        prepend-icon="mdi-account-outline"
                                        :label="$t('Apellido')"
                                        :value="houseInfo[0].main_residents[0].idUser.last_name"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                        class="pl-3 pr-3"
                                        prepend-icon="mdi-email"
                                        label="E-Mail"
                                        :value="houseInfo[0].main_residents[0].idUser.email"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                        class="pl-3 pr-3"
                                        prepend-icon="mdi-cellphone"
                                        :label="$t('celular')"
                                        :value="houseInfo[0].main_residents[0].idUser.cellNumber"
                                        readonly
                                        outlined
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="3">
                    <v-card-text>
                        <v-data-table
                                :headers="headersResident"
                                :items="houseInfo[0].residents"
                                class="elevation-1"
                        >
                            <template v-slot:item.puede_enviar="{ item }">
                                <v-icon
                                        v-if="item.puede_enviar === true"
                                        medium
                                        color="primary"
                                        class="mr-2"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon
                                        v-if="item.puede_enviar === false"
                                        medium
                                        color="red"
                                        class="mr-2"
                                >
                                    mdi-close
                                </v-icon>
                                {{ item.puede_enviar ? $t('Si') : 'No' }}
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon
                                        medium
                                        color="grey"
                                        class="mr-2"
                                        @click="editResident(item)"
                                >
                                    mdi-account-search
                                </v-icon>
                            </template>
                        </v-data-table>
                        <v-divider></v-divider>
                        <br>
                        {{$t('msg_reconoce_residentes')}}
                        <v-radio-group
                            row
                            v-model="confirm"
                            name="confirm"
                            :mandatory="false"
                        >
                            <v-radio
                                class="pl-3 pr-3"
                                :label="$t('Si')"
                                value=true
                                outlined
                            ></v-radio>
                            <v-radio
                                class="pl-3 pr-3"
                                label="No"
                                value=false
                                outlined
                            ></v-radio>
                        </v-radio-group>
                        <br>
                        <v-btn
                            class="align-center"
                            color="primary"
                            :loading="loading"
                            @click="activateHouse()"
                        >
                            {{$t('enviar')}}
                        </v-btn>
                    </v-card-text>
                </v-window-item>
            </v-window>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn
                    :hidden="step === 1 "
                    color="primary"
                    depressed
                    @click="step--"
                >
                    <v-icon left>mdi-arrow-left-bold</v-icon>
                    {{$t('reverso')}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    :hidden="step === 3"
                    color="primary"
                    depressed
                    @click="step++"
                >
                    {{$t('continuar')}}
                    <v-icon right>mdi-arrow-right-bold</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import Vue from 'vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
Vue.component('vue-phone-number-input', VuePhoneNumberInput)

export default {
  name: 'valida_vivienda',
  data: () => ({
    step: 1,
    residentes: [],
    headersResident: [],
    dialog_residente: false,
    editedIndex: -1,
    editedItem: {
      idUser: {
        first_name: '',
        last_name: '',
        email: '',
        cellNumber: '',
        puede_enviar: false,
        avatar: ''
      }
    },
    houseInfo: [],
    confirm: null,
    dialogConfirm: false,
    loading: false
  }),
  beforeUpdate () {
    this.headersResident = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'center',
        sortable: true,
        value: 'idUser.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'center',
        sortable: true,
        value: 'idUser.last_name'
      },
      {
        text: this.$t('celular'),
        align: 'center',
        sortable: true,
        value: 'idUser.cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'center',
        sortable: true,
        value: 'idUser.email'
      }
      // {
      //   text: this.$t('puede_enviar'),
      //   align: 'center',
      //   sortable: true,
      //   value: 'puede_enviar'
      // }
    ]
  },
  created () {
    this.getHouseInfo()
    // this.initialize()
  },
  computed: {
    currentTitle () {
      switch (this.step) {
        case 1: return this.$t('datos_vivienda')
        case 2: return this.$t('datos_residente_principal')
        default: return this.$t('datos_residentes')
      }
    }
  },
  methods: {
    initialize () {
      this.residentes = [
        {
          first_name: 'Andrés',
          last_name: 'Cruz Santiago',
          email: 'algo01@algo.com',
          cellphone: '4567891235',
          password: 'mientras123',
          puede_enviar: true,
          foto_perfil: 'https://library.kissclipart.com/20190227/shw/kissclipart-patient-icon-png-clipart-computer-icons-ac058a2675899cf9.png'
        },
        {
          first_name: 'Francisco',
          last_name: 'Reyes Castillo',
          email: 'algo02@algo.com',
          cellphone: '0123456789',
          password: 'mientras123',
          puede_enviar: false,
          foto_perfil: 'https://library.kissclipart.com/20181114/oke/kissclipart-avatar-profile-png-clipart-computer-icons-avatar-ed68f86e7eead50a.jpg'
        },
        {
          first_name: 'Gabriela',
          last_name: 'Guzmán Castro',
          email: 'algo03@algo.com',
          cellphone: '1212456488',
          password: 'mientras123',
          puede_enviar: false,
          foto_perfil: 'https://cdn1.iconfinder.com/data/icons/avatars-1-5/136/87-512.png'
        }
      ]
    },
    editResident (item) {
      console.log(item)
      this.editedIndex = this.houseInfo[0].residents.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_residente = true
    },
    getHouseInfo () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/get/principal_resident/data/' + this.$route.params['token'] + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          console.log('Información de la Casa: ')
          this.houseInfo = response.data
          console.log(this.houseInfo[0].residents)
        })
        .catch(error => {
          console.log(error)
        })
    },
    activateHouse () {
      if (this.confirm === null) {
        this.dialogConfirm = true
      }
      if (this.confirm === 'true') {
        console.log('Activar Todos los Usuarios')
      //   this.loading = true
      //   const config = {
      //     method: 'patch',
      //     url: 'https://residencial-services.intrare.app/house/activate/deactivate/residents/' + this.$route.params['token'] + '/',
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'authorization': 'Token ' + store.getters.getToken,
      //       'Accept-Language': this.language
      //     }
      //   }
      //   axios(config)
      //     .then(ok => {
      //       this.loading = false
      //       this.$router.push({ path: '/user_confirmed_successfully' })
      //     })
      //     .catch(error => {
      //       if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
      //         this.errores = error.response.data
      //         this.$store.commit('snackbar_activate_true')
      //         this.$store.commit('snackbar_change_color', 'error')
      //         this.$store.commit('snackbar_change_message', this.errores[0])
      //         setTimeout(this.clear, 3000)
      //       } else {
      //         if (error.response.status === 404) {
      //           this.$store.commit('snackbar_activate_true')
      //           this.$store.commit('snackbar_change_color', 'error')
      //           this.$store.commit('snackbar_change_message', this.errores[0])
      //           setTimeout(this.clear, 3000)
      //           this.$store.commit('snackbar_change_color', 'success')
      //           this.$store.commit('snackbar_activate_false')
      //         }
      //       }
      //     })
      //     .finally(() => (this.loading = false))
      } else {
        if (this.confirm === 'false') {
          console.log('Eliminar Todos los Usuarios')
          // const config = {
          //   method: 'delete',
          //   url: 'https://residencial-services.intrare.app/house/activate/deactivate/residents/' + this.$route.params['token'] + '/',
          //   headers: {
          //     'Content-Type': 'application/json',
          //     'Accept-Language': this.language,
          //     'authorization': 'Token ' + store.getters.getToken
          //   }
          // }
          // axios(config).then(ok => {
          //   this.$store.commit('snackbar_activate_true')
          //   this.$store.commit('snackbar_change_color', 'warning')
          //   this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_delete'))
          //   setTimeout(this.clear, 3000)
          //   this.dialogRemoveInvitation = false
          //   this.getInvitationsSend(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
          // })
          //   .catch(error => {
          //     if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          //       this.errores = error.response.data
          //     }
          //   })
        }
      }
    }
  }
}
</script>

<style scoped>
    .wrapper{
        width:240px;
        height:240px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #81c81b;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
